var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73053 0.349352C6.98743 0.0762576 7.41499 0.0762576 7.68087 0.349352C7.93777 0.61322 7.93777 1.05239 7.68087 1.31564L2.86209 6.26517H18.7634C19.1341 6.26578 19.4287 6.5684 19.4287 6.94913C19.4287 7.32987 19.1341 7.64233 18.7634 7.64233H2.86209L7.68087 12.5826C7.93777 12.8557 7.93777 13.2955 7.68087 13.5588C7.41499 13.8319 6.98683 13.8319 6.73053 13.5588L0.770979 7.43751C0.505098 7.17364 0.505098 6.73447 0.770979 6.47122L6.73053 0.349352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c1265b2de548937783f19dd1ae7f77ac.svg";
export { ForwardRef as ReactComponent };